export const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export const inputCls =
  'w-full rounded-xl border border-brand-line bg-white px-4 py-3 text-sm font-semibold text-brand-ink placeholder:text-brand-dim placeholder:font-normal outline-none transition-all duration-300 focus:border-brand-blue focus:ring-4 focus:ring-brand-blue/10';
